import { render, staticRenderFns } from "./firm-admin-invite.vue?vue&type=template&id=61cd4a0c&"
import script from "./firm-admin-invite.vue?vue&type=script&lang=js&"
export * from "./firm-admin-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports